
import { Component, Prop, Vue } from 'vue-property-decorator';
import IconChip from '@/core/components/IconChip.vue';
import withdrawIconSVG from '@/assets/images/withdrawIcon.svg';
import { LoanProjectionEducationalInfo } from '@/loan/types/loan-projection-educational-info';
import { UtilHelper } from '@/util/helper';
import FlipCard from '@/core/components/FlipCard.vue';
import { LoanDetails } from '@/loan/types/loan-details';
import StatusBadge from '@/core/components/StatusBadge.vue';
import { namespace } from 'vuex-class';
import SuggestedAutopay from '@/loan/pages/LoanSummary/components/SuggestedAutopay.vue';
import LoanTakeBackExplainModal from '@/loan/components/LoanTakeBackExplainModal.vue';

const loanNamespace = namespace('loan');

@Component({
	components: {
		IconChip,
		FlipCard,
		StatusBadge,
		SuggestedAutopay,
		LoanTakeBackExplainModal,
	},
})
export default class PayingAhead extends Vue {
	public formatDollar = UtilHelper.formatDollar;

	@Prop({ required: true })
	public info!: LoanProjectionEducationalInfo;

	@Prop({ required: true })
	public isAutopayOn!: boolean;

	@loanNamespace.Getter('autopayPaymentFrequencyText')
	public autopayPaymentFrequencyText!: string;

	@loanNamespace.Getter('outstandingFees')
	public outstandingFees!: number;

	@loanNamespace.Getter('autopayTotalAmount')
	public autopayTotalAmount!: number;

	@Prop({ required: true })
	public loanDetails!: LoanDetails;

	@Prop({ required: true })
	public loanId!: string;

	public icon = withdrawIconSVG;

	public showModal: boolean = false;

	flipped: boolean = false;

	public formatDateForDisplay = UtilHelper.formatDateForDisplay;
}
